/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { Platform } from 'react-native';
import DeviceInfo from 'react-native-device-info';

interface NavigatorUABrandVersion {
  brand: string;
  version: string;
}

interface NavigatorUAData {
  brands: NavigatorUABrandVersion[];
  mobile: boolean;
  platform: string;
}

type NavigatorWithUAData = Navigator & { userAgentData?: NavigatorUAData };

let platformInfo: string | null = null;

export const initializePlatformInfo = async () => {
  if (platformInfo !== null) return platformInfo;
  if (Platform.OS === 'web') {
    try {
      const nav: NavigatorWithUAData = navigator;
      if (nav.userAgentData) {
        const brands = nav.userAgentData.brands
          .map((b) => `${b.brand} ${b.version}`)
          .join(', ');
        const platform = nav.userAgentData.platform;
        platformInfo = `Web/${brands} ${platform}`;
      } else {
        platformInfo = `Web/${navigator.userAgent}`;
      }
    } catch {
      platformInfo = `Web/${navigator.userAgent}`;
    }
  } else {
    try {
      const systemName = DeviceInfo.getSystemName();
      const systemVersion = DeviceInfo.getSystemVersion();
      const deviceName = await DeviceInfo.getDeviceName();
      platformInfo = `${Platform.OS}/${systemName} ${systemVersion} ${deviceName}`;
    } catch {
      platformInfo = `${Platform.OS}/Unknown`;
    }
  }
};

export const getPlatformInfo = () => {
  if (platformInfo === null) {
    return initializePlatformInfo();
  }
  return platformInfo;
};
